import { useQuery } from '@tanstack/react-query';
import { eduplayClient } from '@/data/@clients';
import type { EduplayCourse } from '@/data/eduplay/interfaces';

export const useIndexMyCourses = () => {
  return useQuery<EduplayCourse[]>({
    queryKey: ['my-courses'],
    queryFn: async () => await eduplayClient.get('/meus-cursos'),
  });
};
